
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "CreateInternationalTransferQuoteResponse": [
      "CreateInternationalTransferQuoteResponseError",
      "CreateInternationalTransferQuoteResponseSuccess"
    ],
    "CreditCardInterface": [
      "CreditCard",
      "CreditCardPendingOrder"
    ],
    "FeatureFilter": [
      "RoleFilter",
      "UserFilter"
    ],
    "MerchantOnboardingAccountInfo": [
      "MerchantOnboardingAccountCompanyInfo",
      "MerchantOnboardingAccountIndividualInfo"
    ],
    "PaymentCardInterface": [
      "PaymentCard",
      "PaymentCardPendingOrder"
    ],
    "TeamMembersRequest": [
      "BankTransferRequest",
      "ExpenseClaimRequest",
      "PhysicalPaymentCardOrderRequest",
      "VirtualBudgetCardOrderRequest",
      "VirtualPaymentCardOrderRequest"
    ]
  }
};
      export default result;
    